import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaRedditAlien,
  FaTiktok,
  FaXTwitter,
  FaYoutube,
} from 'react-icons/fa6';
import ContactForm from './ContactForm';
import Logo from '../common/Logo';

// Mirrors the header's labels so one destination never has two names. "For
// Clinicians" stays: it is now the only nav route to the clinician block.
const SITE_PAGES = [
  { label: 'Conditions', href: '#categories' },
  { label: 'About', href: '#about' },
  { label: 'Wiki', href: '#wiki' },
  { label: 'FAQ', href: '#faq' },
  { label: 'For Clinicians', href: '#clinicians' },
];

const SOCIALS = [
  { label: 'Instagram', Icon: FaInstagram, href: '#instagram' },
  { label: 'YouTube', Icon: FaYoutube, href: '#youtube' },
  { label: 'X', Icon: FaXTwitter, href: '#x' },
  { label: 'TikTok', Icon: FaTiktok, href: '#tiktok' },
  { label: 'LinkedIn', Icon: FaLinkedinIn, href: '#linkedin' },
  { label: 'Facebook', Icon: FaFacebookF, href: '#facebook' },
  { label: 'Reddit', Icon: FaRedditAlien, href: '#reddit' },
];

const LEGAL = [
  { label: 'Privacy Policy', href: '#privacy' },
  { label: 'Terms of Use', href: '#terms' },
  { label: 'Cookie Policy', href: '#cookies' },
  { label: 'Accessibility', href: '#accessibility' },
];

export default function Footer() {
  return (
    <footer className="mm-footer" id="clinicians">
      {/* -- Clinician recruitment ------------------------------------- */}
      {/* Centred single column: with the roster of names gone there is no
          second column to balance against, and a half-width block left of
          empty space reads as a layout fault rather than a choice. */}
      <div className="mm-footer__top">
        <Container>
          <div className="mm-footer__pitch">
            <h2 className="mm-footer__pitch-title">Are you a verified therapist?</h2>
            <p className="mm-footer__pitch-text">
              Join a directory that puts your credentials, your fees and your
              approach in front of people actively looking for them. No lead
              fees, no commission on sessions.
            </p>
            <Button as={Link} to="/apply" className="mm-footer__pitch-cta">
              Start your application
            </Button>
          </div>
        </Container>
      </div>

      {/* -- Main footer columns --------------------------------------- */}
      {/* Target for the nav's "Connect" link: this block holds both the
          contact form and the social buttons. */}
      <div className="mm-footer__main" id="connect">
        <Container>
          <Row className="g-5">
            <Col lg={3} md={12}>
              {/* Full brand colours read fine on the navy panel, so the mark
                  keeps its blue and green here rather than going mono. */}
              <Logo
                wordmark="MindlyFriend"
                tagline="Your safe space to heal"
                markSize={40}
                className="mm-footer__brand-mark"
              />
              <p className="mm-footer__tagline">
                Verified therapists, honest pricing, and a search that starts
                with how you feel.
              </p>
            </Col>

            <Col lg={3} md={4} sm={6}>
              <h3 className="mm-footer__heading">Site Pages</h3>
              <ul className="mm-footer__links">
                {SITE_PAGES.map((page) => (
                  <li key={page.label}>
                    <a href={page.href}>{page.label}</a>
                  </li>
                ))}
              </ul>
            </Col>

            <Col lg={3} md={8} sm={6}>
              <h3 className="mm-footer__heading">Stay in touch</h3>
              <ContactForm />
            </Col>

            <Col lg={3} md={12}>
              <h3 className="mm-footer__heading">Connect with MindlyFriend</h3>
              <div className="mm-socials">
                {SOCIALS.map(({ label, Icon, href }) => (
                  <a
                    key={label}
                    href={href}
                    className="mm-socials__btn"
                    aria-label={`MindlyFriend on ${label}`}
                  >
                    <Icon size={17} aria-hidden="true" />
                  </a>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* -- Sub-footer ------------------------------------------------ */}
      <div className="mm-footer__bottom">
        <Container>
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
            <span>
              &copy; {new Date().getFullYear()} MindlyFriend. All rights reserved.
            </span>
            <ul className="mm-footer__legal">
              {LEGAL.map((item) => (
                <li key={item.label}>
                  <a href={item.href}>{item.label}</a>
                </li>
              ))}
            </ul>
          </div>
        </Container>
      </div>
    </footer>
  );
}
